export const defaultColor = '#d4d4d4';
